// Display-only formatting for topic text.
// These do NOT modify stored data — the database and API keep their raw
// representation (pipe separators, raw SRA spec casing). Rendering sites
// use these helpers to present cleaner text to the user.

// Replace pipe separators used in CSV source with " · " (middle dot).
// Example: "Express terms|Implied terms" → "Express terms · Implied terms"
export function formatCovers(covers) {
  if (!covers) return null;
  return covers.split('|').map(s => s.trim()).filter(Boolean).join(' · ');
}

// Cleanup L3 subtopic names for display.
//   - Capitalise the first letter
//   - Replace "/" with ", " (e.g. "sole trader/partnership/LLP" →
//     "Sole trader, partnership, LLP")
// The / replacement is aggressive but acceptable for the current taxonomy
// (no statute citations like "s.14/15" appear in L3 names — those live in
// the `detail` field, not `subtopic`).
export function cleanSubtopicName(name) {
  if (!name) return '';
  let cleaned = name.charAt(0).toUpperCase() + name.slice(1);
  cleaned = cleaned.replace(/\//g, ', ');
  return cleaned;
}
